export default {
  // Accent — used for interactive elements (buttons, active states, links)
  primary: "#9747FF",
  primaryLight: "#B27CFF",
  primaryDark: "#6A35EE",

  // Neutral darks
  secondary: "#252525",
  secondaryLight: "#333333",
  secondaryDark: "#181818",

  // Backgrounds — true black executive
  bgPrimary:   "#000000",
  bgSecondary: "#0D0D0D",
  bgTertiary:  "#161616",
  bgElevated:  "#1F1F1F",

  // Text hierarchy
  textPrimary:   "#FFFFFF",
  textSecondary: "#9A9A9A",
  textMuted:     "#555555",

  // Borders
  borderPrimary:   "#2C2C2C",
  borderSecondary: "#1A1A1A",

  // Status colors — unchanged for data legibility
  success:      "#34C759",
  successLight: "#4CD964",
  warning:      "#FF9F0A",
  warningLight: "#FFBF40",
  error:        "#FF453A",
  errorLight:   "#FF6961",
  info:         "#5AC8FA",
  infoLight:    "#7DD3FC",

  // Table/card specific
  tableHeader:   "#0A0A0A",
  tableBg:       "#060606",
  tableHover:    "#1A1A1A",
  cardHighlight: "#141414",

  // Legacy aliases — remapped so no consuming component breaks
  yellow:       "#9747FF",
  yellowAcademy:"#B27CFF",
  yellowDark:   "#6A35EE",
  green:        "#34C759",
  red:          "#FF453A",
  second:       "#B27CFF",
  third:        "#EC48B4",
  fourth:       "#000000",
  dark:         "#252525",
  gold:         "#9747FF",
  grey:         "#9A9A9A",
  greyLight:    "#D0D0D0",
  text2:        "#FFFFFF",
  text:         "#9A9A9A",
  bg:           "#0D0D0D",
  bgAcademy:    "#000000",
  blue:         "#252525",
  bgLight:      "#333333",
  darkBlue:     "#252525",
  light:        "#FFFFFF",
  grey2:        "#707070",
  first2:       "#8E5DD7",
  link:         "#5AC8FA",
  facebook:     "#4267B2",
  google:       "#EA4335",
  lightBlue:    "#5AC8FA",

  transparent:     "rgba(0,0,0,0.0)",
  semiTransparent: "rgba(0,0,0,0.6)",
  overlay:         "rgba(0,0,0,0.88)",
  white:           "#FFFFFF",
  black:           "#000000",
};
